import { Button } from 'blaze-ui/Button'
import { Plus } from 'blaze-ui/icons'
import { useModals } from 'almanac-ui/Modal'
import { Wizards } from 'components/Wizards/Wizards'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useBrandVoices } from 'hooks/useBrandVoices'

export const CreateNewButton = () => {
  const currentWorkspace = useCurrentWorkspace()
  const { data: voices } = useBrandVoices(currentWorkspace, { cacheTime: 1000 * 60 * 5 })
  const initialValues = { brand_voice_id: voices?.[voices.length - 1]?.id }
  const { openModal } = useModals()

  return (
    <Button
      variant="tertiary"
      size="md"
      frontIcon={Plus}
      onPress={() => {
        openModal(Wizards, { initialValues })
      }}
    >
      Create New
    </Button>
  )
}
